import type { TestCoding } from '@medplum/health-gorilla-core';

/**
 * Resolves Health Gorilla test search results: try preferred order code first (when set),
 * then fall back to searching by display name.
 */
export async function searchLabOrderTestCodings(
  searchAvailableTests: (query: string) => Promise<TestCoding[]>,
  searchName: string,
  preferredCode?: string
): Promise<TestCoding[]> {
  try {
    const resultsByCode = preferredCode ? await searchAvailableTests(preferredCode) : [];
    if (resultsByCode.length > 0) {
      return resultsByCode;
    }
    return await searchAvailableTests(searchName);
  } catch {
    return [];
  }
}
